"use strict"

import {observable, action} from "mobx"

class CheckMedicineCardDialogStore {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new CheckMedicineCardDialogStore()
export default singleton
